import { Outlet, ScrollRestoration } from "react-router-dom";
import { GrainOverlay } from "@vb/ui";
import { SiteHeader } from "./SiteHeader.js";
import { SiteFooter } from "./SiteFooter.js";

export function MarketingShell() {
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg-0)", color: "var(--fg-1)" }}>
      <GrainOverlay />
      <SiteHeader />
      <main style={{ position: "relative", zIndex: 3 }}>
        <Outlet />
      </main>
      <SiteFooter />
      <ScrollRestoration />
    </div>
  );
}
